

'use strict';



function setupLinkClick () {
    const links = document.querySelectorAll('main a');

    links
        .forEach(link => link.addEventListener('click', () => {
            window.ojtag('internal_link_click', {
                link_text: link.innerHTML,
                link_target: link.href,
                link_type: 'Content',
            });
        }));
}


function setupLanguageSwitchHeader () {
    const dropdown = document.querySelector('.language-selector');
    const links = dropdown.querySelectorAll('ul a');
    const currentLang = dropdown.querySelector('.name').innerHTML.toUpperCase();

    links
        .forEach(link => link.addEventListener('click', evt => {
            const nextLang = link.innerHTML.toUpperCase();

            if ( currentLang !== nextLang ) {
                evt.preventDefault();

                window.ojtag('language_switch', {
                    location_id: 'Header language switch',
                    curr_lang: currentLang,
                    next_lang: nextLang,
                });

                window.location = link.href;
            }
        }, { once: true }));
}


function setupLanguageSwitchMobileNav () {
    const holder = document.querySelector('.mobile-nav .language-holder');
    const links = holder.querySelectorAll('a');
    const currentLang = holder.querySelector('.current').innerHTML.toUpperCase();

    links
        .forEach(link => link.addEventListener('click', evt => {
            const nextLang = link.innerHTML.toUpperCase();

            if ( currentLang !== nextLang ) {
                evt.preventDefault();

                window.ojtag('language_switch', {
                    location_id: 'Mobile nav language switch',
                    curr_lang: currentLang,
                    next_lang: nextLang,
                });

                window.location = link.href;
            }
        }, { once: true }));
}


function setupLanguageSwitchGoogle () {
    const htmlRoot = document.getElementsByTagName('html')[0];
    const originalLanguage = htmlRoot.getAttribute('lang')
    let languageAttr = originalLanguage;

    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === "attributes") {
                const mutatedAttr = mutation.target.getAttribute('lang') === 'auto' ?
                    originalLanguage :
                    mutation.target.getAttribute('lang');

                if ( mutatedAttr !== languageAttr ) {
                    window.ojtag('language_switch', {
                        location_id: 'Google language switch',
                        curr_lang: languageAttr,
                        next_lang: mutatedAttr,
                    });

                    languageAttr = mutatedAttr;
                }
            }
        });
    });

    observer.observe(htmlRoot, {
        attributes: true,
    });
}


function setupButtonClick () {
    const buttons = document.querySelectorAll('[data-ga-button]');

    buttons.forEach(btn => btn.addEventListener('click', () => {
        if ( btn.dataset.gaButton && btn.href ) {
            window.ojtag('button_click', {
                button_id: btn.dataset.gaButton,
                button_target: btn.href,
            });
        }
    }));
}


export default function setupGA4 () {
    setupLinkClick();
    setupLanguageSwitchHeader();
    setupLanguageSwitchGoogle();
    setupLanguageSwitchMobileNav();
    setupButtonClick();
}
